var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { createSlice } from "@reduxjs/toolkit";
import { alert, request, loadingModal } from "@pagser/common";
var initialState = {
    loading: true,
    list: [],
    totalCount: 0,
};
export var commentsSlice = createSlice({
    name: "comments",
    initialState: initialState,
    reducers: {
        setLoading: function (state, action) {
            state.loading = action.payload;
        },
        setComments: function (state, action) {
            state.list = action.payload;
        },
        // when fetch new comments (in the infinite loading)
        addComments: function (state, action) {
            state.list = __spreadArray(__spreadArray([], state.list, true), action.payload, true);
        },
        // adds a new comment
        setNewComment: function (state, action) {
            state.list = __spreadArray([action.payload], state.list, true);
        },
        // adds a new reply
        setNewReply: function (state, action) {
            state.list = __spreadArray([], state.list, true).map(function (c) {
                if (c.id === action.payload.inReplyTo) {
                    if (typeof c.replies === "number") {
                        c.replies += 1;
                    }
                    else {
                        c.replies.push(action.payload);
                    }
                    c.highlightedReplies.push(action.payload);
                }
                return c;
            });
        },
        changeCommentStatus: function (state, action) {
            var status = action.payload.status;
            state.list = __spreadArray([], state.list, true).map(function (c) {
                // If commentId matched the comment in store, go for it and do the changes
                // otherwise just return the comment without any modification
                if (c.id === action.payload.commentId) {
                    // If we need to change the status of a reply
                    if (action.payload.replyId) {
                        // Change the status of a reply in 'replies' store or in 'highlightedReplies' store
                        var type = typeof c.replies === "number" && c.highlightedReplies.length > 0
                            ? "highlightedReplies"
                            : "replies";
                        c[type] = c[type].map(function (rep) {
                            if (rep.id === action.payload.replyId) {
                                // Change the status of the reply comment to either show the reply form or hide it
                                rep.status = status;
                                // This will be the label value shown on add reply form to inform users
                                // who they're replying to, we won't show this label if user is replying to him/her self.
                                if (status === "add-reply" &&
                                    action.payload.userId !== rep.author.id)
                                    rep.toName = action.payload.toName;
                            }
                            return rep;
                        });
                        // If we need to change the status of a main comment
                    }
                    else {
                        c.status = status;
                    }
                }
                return c;
            });
        },
        setFetchedReplies: function (state, action) {
            state.list = __spreadArray([], state.list, true).map(function (c) {
                if (c.id === action.payload.commentId) {
                    c.showReplies = true;
                    c.replies = action.payload.replies;
                }
                return c;
            });
        },
        // accepts commentId
        hideReplies: function (state, action) {
            state.list = __spreadArray([], state.list, true).map(function (c) {
                if (c.id === action.payload) {
                    c.showReplies = false;
                    c.highlightedReplies = [];
                }
                return c;
            });
        },
        setLikes: function (state, action) {
            state.list = __spreadArray([], state.list, true).map(function (c) {
                var mainId = action.payload.inReplyTo
                    ? action.payload.inReplyTo
                    : action.payload.commentId;
                // Find the main comment
                if (c.id === mainId) {
                    // If we need to change the likes of a reply
                    if (action.payload.inReplyTo) {
                        // Change the likes of a reply in 'replies' store or in 'highlightedReplies' store
                        var type = typeof c.replies === "number" && c.highlightedReplies.length > 0
                            ? "highlightedReplies"
                            : "replies";
                        c[type] = c[type].map(function (rep) {
                            if (rep.id === action.payload.commentId) {
                                // Change the likes of the reply comment
                                rep.likes = action.payload.likes;
                            }
                            return rep;
                        });
                        // If we need to change the likes of a main comment
                    }
                    else {
                        c.likes = action.payload.likes;
                    }
                }
                return c;
            });
        },
        setEditedComment: function (state, action) {
            state.list = __spreadArray([], state.list, true).map(function (c) {
                var mainId = action.payload.inReplyTo
                    ? action.payload.inReplyTo
                    : action.payload.commentId;
                // Find the main comment
                if (c.id === mainId) {
                    // If we need to change the text of a reply
                    if (action.payload.inReplyTo) {
                        // Change the text of a reply in 'replies' store or in 'highlightedReplies' store
                        var type = typeof c.replies === "number" && c.highlightedReplies.length > 0
                            ? "highlightedReplies"
                            : "replies";
                        c[type] = c[type].map(function (rep) {
                            if (rep.id === action.payload.commentId) {
                                // Change the text of the reply comment
                                rep.text = action.payload.newComment;
                                rep.status = "normal";
                            }
                            return rep;
                        });
                        // If we need to change the text of a main comment
                    }
                    else {
                        c.text = action.payload.newComment;
                        c.status = "normal";
                    }
                }
                return c;
            });
        },
        deleteAMainComment: function (state, action) {
            var index = state.list.findIndex(function (c) { return c.id === action.payload; });
            state.list = __spreadArray(__spreadArray([], state.list.slice(0, index), true), state.list.slice(index + 1), true);
        },
        setTotalCount: function (state, action) {
            state.totalCount = action.payload;
        },
    },
});
// Fetches new comments including when user scrolls to the bottom
export var fetchComments = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var pageId, commentsLength, portion, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                pageId = getState().page.id;
                commentsLength = getState().comments.list.length;
                portion = commentsLength / 10 + 1;
                dispatch(setLoading(true));
                return [4 /*yield*/, request.get("/comments/".concat(pageId, "?portion=").concat(portion), {
                        auth: true,
                    })];
            case 1:
                response = _a.sent();
                if (commentsLength) {
                    dispatch(addComments(response.comments));
                }
                else {
                    dispatch(setComments(response.comments));
                }
                dispatch(setTotalCount(response.length));
                dispatch(setLoading(false));
                return [2 /*return*/];
        }
    });
}); }; };
// Sends a request to server to add a comment for the page or a comment reply for another comment
export var addComment = function (comment, inReplyTo, inReplyToCommentReply, inReplyToUserName) {
    if (inReplyTo === void 0) { inReplyTo = null; }
    if (inReplyToCommentReply === void 0) { inReplyToCommentReply = null; }
    if (inReplyToUserName === void 0) { inReplyToUserName = null; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadingModal("Adding your comment...");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, request.post("/comment/".concat(getState().page.id), { text: comment, inReplyTo: inReplyTo, inReplyToCommentReply: inReplyToCommentReply }, {
                            auth: true,
                            alert: false,
                        })];
                case 2:
                    response = _a.sent();
                    if (response.inReplyTo) {
                        dispatch(setNewReply(__assign(__assign({}, response.comment), { inReplyToUser: inReplyToCommentReply && inReplyToUserName ? inReplyToUserName : undefined })));
                        dispatch(changeCommentStatus({
                            commentId: inReplyTo,
                            status: "normal",
                            replyId: inReplyToCommentReply,
                            userId: getState().user.id,
                        }));
                        alert("Your reply was added successfully.", "success");
                    }
                    else {
                        dispatch(setNewComment(response.comment));
                        alert("Your comment was added successfully.", "success");
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    request.handleError(e_1);
                    return [3 /*break*/, 4];
                case 4:
                    loadingModal();
                    return [2 /*return*/];
            }
        });
    }); };
};
// Fetches all replies of a comment
export var fetchReplies = function (id) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.get("/comment/".concat(id, "/replies"), {
                        auth: true,
                    })];
                case 1:
                    response = _a.sent();
                    dispatch(setFetchedReplies({
                        replies: response.replies,
                        commentId: response.commentId,
                    }));
                    return [2 /*return*/];
            }
        });
    }); };
};
// Sends a request to server to like or unlike a comment
export var likeComment = function (commentId, inReplyTo) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var response, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.patch("/rate/comment/".concat(commentId), null, {
                            auth: true,
                            alert: false,
                        })];
                case 1:
                    response = _a.sent();
                    dispatch(setLikes({ likes: response.likes, inReplyTo: inReplyTo, commentId: commentId }));
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    if (e_2.status === 401) {
                        alert("Please log in to like a comment.");
                    }
                    else {
                        request.handleError(e_2);
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
// Sends a request to server to edit a comment
export var editComment = function (commentId, newComment) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadingModal("Updating your comment...");
                    return [4 /*yield*/, request.put("/comment/".concat(commentId), { text: newComment }, {
                            auth: true,
                        })];
                case 1:
                    response = _a.sent();
                    dispatch(setEditedComment({
                        newComment: response.newComment,
                        commentId: response.commentId,
                        inReplyTo: response.inReplyTo != null ? String(response.inReplyTo) : "",
                    }));
                    alert("Your comment was updated successfully.", "success");
                    loadingModal();
                    return [2 /*return*/];
            }
        });
    }); };
};
// Sends a request to server to delete a comment
export var deleteComment = function (commentId, callback) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadingModal("Deleting your comment...");
                    return [4 /*yield*/, request.delete("/comment/".concat(commentId), {
                            auth: true,
                        })];
                case 1:
                    response = _a.sent();
                    loadingModal();
                    // If the comment deleted was a reply comment
                    if (typeof response.parent !== "boolean" && response.parent) {
                        // Fetch replies of that comment again
                        dispatch(fetchReplies(String(response.parent)));
                    }
                    else {
                        // In this case the comment that was deleted is a main comment, so we remove
                        // it entirely from the store along with all of its replies
                        dispatch(deleteAMainComment(response.commentId));
                    }
                    // Might be used to close the modal
                    callback();
                    alert("Your comment was deleted successfully.", "success");
                    return [2 /*return*/];
            }
        });
    }); };
};
export var setLoading = (_a = commentsSlice.actions, _a.setLoading), setComments = _a.setComments, setTotalCount = _a.setTotalCount, addComments = _a.addComments, setNewComment = _a.setNewComment, setNewReply = _a.setNewReply, changeCommentStatus = _a.changeCommentStatus, setFetchedReplies = _a.setFetchedReplies, hideReplies = _a.hideReplies, setLikes = _a.setLikes, setEditedComment = _a.setEditedComment, deleteAMainComment = _a.deleteAMainComment;
export var selectLoading = function (state) { return state.comments.loading; };
export var selectComments = function (state) { return state.comments.list; };
export var selectTotalCount = function (state) { return state.comments.totalCount; };
export default commentsSlice.reducer;
